import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Lenis drives the scroll; GSAP's ticker drives Lenis so ScrollTrigger
// animations stay perfectly in sync with the smoothed scroll position.
export default function SmoothScroll({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    // Respect the visitor's OS-level "reduce motion" setting — native scroll instead.
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });

    lenis.on("scroll", ScrollTrigger.update);
    const tick = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(tick);
    gsap.ticker.lagSmoothing(0);

    // Let the voice agent (public/js/agent-entity.js) scroll through Lenis so
    // its show_section moves don't fight the smooth-scroll engine.
    window.mleLenis = lenis;

    return () => {
      gsap.ticker.remove(tick);
      if (window.mleLenis === lenis) delete window.mleLenis;
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    ScrollTrigger.refresh();
  }, [pathname]);

  return children;
}
